var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-asset"},[_c('span',{staticClass:"state-layer"},[_c('span',{staticClass:"label__medium"},[_vm._v(_vm._s(_vm.text))]),(_vm.$slots['icon'])?_c('span',{staticClass:"icon material-symbols-outlined"},[_vm._t("icon")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }